type DisclaimerProps = {
};

export const Disclaimer: React.FC<DisclaimerProps> = (props) => {
  return (
    <></>
  );
};
